module.exports = __webpack_public_path__ + "img/bg_recycle.9041c14a.jpg";